export default __webpack_public_path__ + "static/media/Gregorio_Martocci_-_Full_Stack_Web_Developer_&_Designer.3ef3433e.pdf";